<script>
  import { navigate } from "svelte-routing";
  import { Icon } from "t2c-components";

  export let lawcaseId;
  export let id;
  export let name;
  export let icon = "folder";

  const handleNavigate = () => {
    const route = `/lawcase/${lawcaseId}/folder/${id}`;
    navigate(route);
  };
</script>

<div class="container" on:click={handleNavigate}>
  <div class="title">
    <Icon {icon} fill="#1f363d" />
    <div>
      <h1>{name}</h1>
    </div>
  </div>
</div>

<style>
  .container {
    display: flex;
    align-items: center;
    padding: 1rem 0;
    margin: 12px 0;
  }

  .title {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  h1 {
    font-weight: 300;
    font-size: 22px;
    word-wrap: break-word;
    margin-left: 10px;
    line-height: 1;
  }
</style>
